import React from "react";
import ServicePage from "../components/ServicePage";

const Icon = ({ d, size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    {Array.isArray(d) ? d.map((p, i) => <path key={i} d={p} />) : <path d={d} />}
  </svg>
);
const BoxIcon      = (p) => <Icon {...p} d={["M21 8l-9-5-9 5 9 5 9-5z","M3 8v8l9 5 9-5V8","M12 13v8"]} />;
const ScaleIcon     = (p) => <Icon {...p} d={["M12 3v18","M5 7l-3 8a4 4 0 008 0l-3-8","M19 7l-3 8a4 4 0 008 0l-3-8","M5 7h14"]} />;
const ShieldIcon    = (p) => <Icon {...p} d="M12 2l8 3.5v5.5c0 5-3.4 9-8 11-4.6-2-8-6-8-11V5.5z" />;
const BuildingIcon  = (p) => <Icon {...p} d={["M4 22V4a1 1 0 011-1h6a1 1 0 011 1v18","M12 22V9a1 1 0 011-1h6a1 1 0 011 1v13","M8 6h.01M8 10h.01M8 14h.01","M16 12h.01M16 16h.01"]} />;

export default function Marchandises() {
  return (
    <ServicePage
      title="Transport de marchandises"
      subtitle="Une alternative fiable à la route pour vos marchandises, matériaux et équipements - idéale pour les entreprises et PME du Gabon."
      subject="Demande de transport de marchandises"
      formIntro="Décrivez ce que vous souhaitez transporter (nature, quantité, poids) et le trajet souhaité - nous reviendrons vers vous avec un devis adapté."
      routeLabel="Trajet souhaité (ex : Owendo → Franceville)"
      features={[
        [BoxIcon, "Tous types de marchandises", "Matériaux de construction, équipements, marchandises générales - pour particuliers comme professionnels."],
        [ScaleIcon, "Grandes capacités", "Adapté aux volumes que la route ne permet pas toujours de transporter facilement."],
        [ShieldIcon, "Fiable en toute saison", "Une alternative sûre à la route, notamment pendant la saison des pluies."],
        [BuildingIcon, "Pour les entreprises", "PME et grandes entreprises : contactez-nous pour une offre commerciale ou un devis sur mesure."],
      ]}
    />
  );
}
